import { call, put, fork, delay, select, cancel, cancelled } from 'redux-saga/effects'
import { NdlFlowRunsActions, NdlFlowRunsSelectors } from '../reducers/NdlFlowRunsRedux'

export const findNdlFlowRuns = function* (api, { payload }) {
  try {
    const query = (payload && payload.query) || payload || {}

    const response = yield call(api.create, 'ndl/flow_runs/filter', query)

    yield put(NdlFlowRunsActions.findSuccess(response))
  } catch (err) {
    yield put(NdlFlowRunsActions.findFailure(err.message))
  }
}

export const createNdlFlowRun = function* (api, { payload }) {
  try {
    const { deployment, ...data } = payload

    const response = yield call(
      api.create,
      'ndl/deployments/' + deployment + '/create_flow_run',
      data,
    )
    yield put(NdlFlowRunsActions.createSuccess(response))
  } catch (err) {
    yield put(NdlFlowRunsActions.createFailure(err.message))
  }
}

let pollTask

function* pollFlowRunsWorker(api) {
  try {
    while (true) {
      let flowRuns = yield select(NdlFlowRunsSelectors.getQueriedNdlFlowRuns)
      if (flowRuns.length === 0) break

      const query = {
        flow_runs: {
          id: { any_: flowRuns.map((fr) => fr.id) },
        },
      }
      const response = yield call(api.create, 'ndl/flow_runs/filter', query)
      const updatedFlowRuns = Array.isArray(response) ? response : []

      flowRuns = flowRuns.map((fr) => updatedFlowRuns.find((u) => u.id === fr.id) || fr)

      yield put(NdlFlowRunsActions.findSuccess(flowRuns))

      yield delay(5000)
    }
  } finally {
    if (yield cancelled()) {
      // console.log('Polling de flowRuns cancelado');
    }
  }
}

export function* watchFlowRuns(api) {
  pollTask = yield fork(pollFlowRunsWorker, api)
}

export function* unwatchFlowRuns() {
  if (pollTask) {
    yield cancel(pollTask)
    pollTask = null
  }
}
